/* eslint-disable no-param-reassign */

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { parsePhoneNumber } from "react-phone-number-input";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import DataTable from "components/Tables/DataTable";
import { toast } from "react-toastify";
import phoneNumbers from "layouts/numbers/data/phoneNumbers";
import MDButton from "components/MDButton";
import { Icon } from "@mui/material";
import Loading from "components/Loading";
import { actions } from "../../store/reducers/numbers";
import Modal from "./modal";

function Numbers() {
  const { getRows, columns } = phoneNumbers();
  const dispatch = useDispatch();
  const [numberToEdit, setNumberToEdit] = useState(null);

  const {
    numbers,
    totalItems,
    page,
    perPage,
    qs,
    initialFetchIsDone,
    locations,
    timezones,
    loading,
  } = useSelector((state) => state.numbers);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setNumberToEdit(null);
  };

  const submit = useCallback(
    (data, call) => {
      data.number = parsePhoneNumber(data.number).number;
      if (numberToEdit) {
        dispatch(
          actions.updateNumber(
            numberToEdit.id,
            data,
            () => {
              toast.success("Number updated successfully");
              handleClose();
            },
            (msg, error) => {
              toast.error(msg || "Number could not be updated");
              call(error);
            }
          )
        );
      } else {
        dispatch(
          actions.addNumber(
            data,
            () => {
              toast.success("Number created successfully");
              handleClose();
            },
            (msg, error) => {
              toast.error(msg || "Number could not be created");
              call(error);
            }
          )
        );
      }
    },
    [numberToEdit, dispatch, handleClose]
  );

  useEffect(() => {
    if (!initialFetchIsDone) {
      dispatch(actions.fetchLocationRequest((err) => toast.error(err)));
      dispatch(actions.fetchTimezoneRequest((err) => toast.error(err)));
    }
  }, []);

  useEffect(() => {
    dispatch(actions.fetchNumberRequest(page, perPage, (err) => toast.error(err)));
  }, [page, perPage, qs]);

  const handleExport = () =>
    dispatch(actions.exportNumberRequest(page, perPage, (err) => toast.error(err)));
  const rows = useMemo(
    () =>
      getRows(
        numbers,
        locations.reduce((all, l) => {
          all[l.id] = l;
          return all;
        }, {}),
        timezones.reduce((all, l) => {
          all[l.id] = l;
          return all;
        }, {}),
        setNumberToEdit
      ),
    [locations, numbers, timezones]
  );
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && <Loading />}
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Phone numbers
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <MDBox pl={3}>
                  <MDButton
                    variant="gradient"
                    color="success"
                    size="medium"
                    disabled={totalItems === 0}
                    aria-label="close"
                    onClick={handleExport}
                  >
                    <Icon fontSize="medium">download</Icon> Export CSV
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "20px" }}
                    variant="gradient"
                    color="primary"
                    size="medium"
                    aria-label="close"
                    onClick={handleOpen}
                  >
                    <Icon fontSize="medium">add</Icon> Add Number
                  </MDButton>
                </MDBox>
                <DataTable
                  entriesPerPage={{ defaultValue: perPage, entries: [5, 10, 15, 20, 50] }}
                  table={{ columns, rows }}
                  isSorted={false}
                  showTotalEntries
                  noEndBorder
                  canSearch
                  totalCount={totalItems}
                  page={page}
                  perPage={perPage}
                  qs={qs}
                  setQs={(s) => dispatch(actions.setNumberQs(s))}
                  gotoPage={(p) => dispatch(actions.setNumberPage(p))}
                  setPageSize={(p) => dispatch(actions.setNumberPerPage(p))}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Modal
        open={!!(open || numberToEdit)}
        handleClose={handleClose}
        onSumbit={submit}
        locations={locations}
        timezones={timezones}
        data={numberToEdit}
        isEdit={numberToEdit !== null}
      />
    </DashboardLayout>
  );
}

export default Numbers;
